export default __webpack_public_path__ + "src/assets/icn-json.e4378daa97c88b8f0fb31874cf5cbc93.svg";